import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { pingCli, type CliStatus } from '../lib/cli-bridge';

export function Settings() {
  const [cli, setCli] = useState<CliStatus | null>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    let cancelled = false;
    pingCli().then((status) => {
      if (cancelled) return;
      setCli(status);
      setChecked(true);
    });
  }, []);

  return (
    <div className="mx-auto max-w-2xl p-6">
      <Link to="/library" className="text-[12px] text-text-muted hover:text-[var(--color-fg)]">
        ← Library
      </Link>
      <h1 className="mt-3 text-lg font-semibold">CLI</h1>
      <p className="mt-1 text-[13px] text-text-subtle">
        The CLI syncs your skills to <code className="font-mono">~/.claude/skills/</code>,{' '}
        <code className="font-mono">~/.codex/skills/</code>, and{' '}
        <code className="font-mono">~/.cursor/rules/</code> so they appear in your AI tools
        automatically.
      </p>

      <section className="mt-5 rounded-lg border bg-surface p-4">
        <h2 className="text-[10px] font-semibold uppercase tracking-wider text-text-muted">
          Status
        </h2>
        <p className="mt-2 flex items-center gap-2 text-[13px]">
          {!checked && <span className="text-text-subtle">Checking localhost:7331…</span>}
          {checked && cli && (
            <>
              <span
                className="h-[8px] w-[8px] rounded-full"
                style={{ background: 'var(--color-success)' }}
              />
              Running · <span className="font-mono">v{cli.version}</span>
              {cli.user && (
                <span className="text-text-subtle">· {cli.user}</span>
              )}
            </>
          )}
          {checked && !cli && (
            <>
              <span
                className="h-[8px] w-[8px] rounded-full"
                style={{ background: 'var(--color-text-subtle)' }}
              />
              <span className="text-text-muted">
                Not detected on localhost:7331 — install and run watch.
              </span>
            </>
          )}
        </p>
      </section>

      <section className="mt-4 rounded-lg border bg-surface p-4">
        <h2 className="text-[10px] font-semibold uppercase tracking-wider text-text-muted">
          Install
        </h2>
        <pre className="mt-3 overflow-x-auto rounded border bg-canvas p-3 font-mono text-[12px] leading-[18px]">
{`npm install -g @skillsou/cli
skillsou login
skillsou watch`}
        </pre>
        <p className="mt-3 text-[12px] text-text-subtle">
          <code className="font-mono">watch</code> runs sync continuously and exposes a
          localhost daemon so the editor's "Install to Claude Code" button works.
        </p>
      </section>
    </div>
  );
}
